import { render } from "./SponsorAbout.vue?vue&type=template&id=4f34cdaa&scoped=true"
import script from "./SponsorAbout.vue?vue&type=script&lang=js"
export * from "./SponsorAbout.vue?vue&type=script&lang=js"

import "./SponsorAbout.vue?vue&type=style&index=0&id=4f34cdaa&lang=scss&scoped=true"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f34cdaa"]])

export default __exports__